module.exports = __webpack_public_path__ + "media/old_images/logo-naturkartan-0c4fe5ab.png";